<template>
    <div class="bg-white shadow p-4 rounded-[8px]">
        <table class="mb-4 w-full text-[10px] border-solid border border-gray-300 text-black">
            <thead
                class="[&>tr_th]:py-1 [&>tr_th]:px-3 [&>tr_th]:border [&>tr_th]:border-solid [&>tr_th]:font-normal [&>tr_th]:border-gray-300">
                <slot name="head"></slot>
            </thead>
            <tbody
                class="[&>tr_td]:py-1 [&>tr_td]:px-3 [&>tr_td]:border [&>tr_td]:border-solid [&>tr_td]:font-normal [&>tr_td]:border-gray-300">
                <slot></slot>
            </tbody>
        </table>

        <vx-button v-if="props.downloadHref"
            block
            download
            size="sm"
            color="muted"
            :href="props.downloadHref">
            Download CSV
            <font-awesome-icon widthAuto :icon="faDownload"></font-awesome-icon>
        </vx-button>
    </div>
</template>
<script setup>
import { faDownload } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxButton } from '@voxie/frontend-components';

const props = defineProps({
    downloadHref: String,
})
</script>
